export interface ParsedKnowledgeLink {
  url: string;
  host: string;
}

const allowedProtocols = new Set(['http:', 'https:']);
const protocolPattern = /^[a-zA-Z][a-zA-Z\d+.-]*:\/\//;

const parseUrlCandidate = (candidate: string): ParsedKnowledgeLink | null => {
  try {
    const parsedUrl = new URL(candidate);

    if (!allowedProtocols.has(parsedUrl.protocol) || !parsedUrl.hostname) {
      return null;
    }

    return {
      url: parsedUrl.toString(),
      host: parsedUrl.hostname,
    };
  } catch {
    return null;
  }
};

export const parseKnowledgeLink = (value: string): ParsedKnowledgeLink | null => {
  const trimmedValue = value.trim();
  if (!trimmedValue) return null;

  return (
    parseUrlCandidate(trimmedValue) ??
    (trimmedValue.includes('://') ? null : parseUrlCandidate(`https://${trimmedValue}`))
  );
};

export const hasKnowledgeLinkProtocol = (value: string): boolean => {
  return protocolPattern.test(value.trim());
};
